import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { message } from 'antd'
import Modal from 'meinian-package/src/component/modal'
import request from 'meinian-package/src/utils/request'
import Icon from 'meinian-package/src/component/icon'
import TextArea from 'meinian-package/src/component/textarea'
import Button from 'meinian-package/src/baseComponent/button'
import { SelectCheck } from 'meinian-package/src/baseComponent/selectBorder'
import { convert } from '../../../common/convert'
import './index.less'

export default (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    // eslint-disable-next-line react/no-deprecated
    ReactDOM.render(<NoteRemind {...props} visible container={div} />, div)
  })
}

export const NoteRemind = ({ visible, onCancel, onOk, title = '短信提醒', option }) => {
  const [_visible, set_Visible] = useState(visible)
  const [val, setVal] = useState({
    targetUserIdList: [],
  })
  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }
  const _ok = async () => {
    if (!val.targetUserIdList.length) {
      message.error('请选择接收人')
      return
    }
    await sendMessage()
    const flag = await onOk?.(val)
    if (flag === false) {
      return
    }
    set_Visible(false)
  }

  const sendMessage = async () => {
    const result = await request.post('/zhikuan/inspiration/blog/notify-mark-blog', {
      collectId: option.collectId,
      targetUserIdList: val.targetUserIdList
    })
    if (result) {
      message.success('短信发送成功')
    }
  }

  return <Modal
    style={{ width: '480px' }}
    visible={_visible}
    onCancel={_cancel}
    onOk={_ok}
    title={title}
    footer={<div className="df-center-space-between">
      <div style={{ color: 'var(--m-text-3)', fontSize: '12px' }}>每条短信之间需间隔十五分钟</div>
      <div>
        <Button type="normal" onClick={_cancel} style={{ marginRight: 8, width: 88 }}>取消</Button>
        <Button type="primary" style={{ width: 88 }} onClick={_ok}>确定</Button>
      </div>
    </div>}
  >
    <div className="mn-public-component-fun-modal-note-remind">
      <div className="mn-public-component-fun-modal-note-remind-select">
        <RecipientSelect
          allowClear
          value={val.targetUserIdList}
          onInit={(v) => {
            setVal(pre => ({ ...pre, targetUserIdList: v }))
          }}
          onChange={(v) => {
            setVal(pre => ({ ...pre, targetUserIdList: v }))
          }}
          inspirationId={option.inspirationId}
        />
      </div>
      <div className="mn-public-component-fun-modal-note-remind-select" style={{ marginTop: '16px' }}>
        <div className="df-center">
          <Icon type="m-pinglun" className="mn-public-component-fun-modal-note-remind-icon" />
          <div className="mn-public-component-fun-modal-note-remind-select-label">消息内容</div>
        </div>
      </div>
      <div style={{ marginTop: '8px' }}>
        <TextArea
          disabled
          value={`【知衣科技】${option.userName}提交了一个款式审核，提醒您尽快登录美念审核，点击打开知衣APP快速审核。`}
          minHeight={132}
          maxHeight={132}
          wrapStyle={{ padding: '8px 12px' }}
          wrapClassName="mn-public-component-fun-modal-note-remind-text-area"
        />
      </div>
    </div>
  </Modal>
}

const RecipientSelect = ({ value, onChange, onInit, inspirationId }) => {
  const [option, setOption] = useState([])

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    const result = await request.get('/zhikuan/inspiration/blog/notify-mark-users', { params: { inspirationId } })
    if (result) {
      setOption(convert(result, 'nickName', 'userId'))
      onInit?.(result.filter(i => i.choose === 1).map(i => i.userId))
    }
  }

  return <SelectCheck
    allowClear
    value={value}
    label={<div className="df-center">
      <Icon type="m-yonghu" className="mn-public-component-fun-modal-note-remind-icon" />
      <div className="mn-public-component-fun-modal-note-remind-select-label">接收人：</div>
    </div>}
    onChange={(v) => onChange(v)}
    option={option}
  />
}
